import metrics from '../browser/metrics';

const SearchService = {};

const BASE_URL = 'https://api.swiftype.com';

const postRequest = (requestUrl, body) =>
  fetch(requestUrl, {
    method: 'POST',
    headers: new Headers({
      'Content-Type': 'application/json'
    }),
    body: JSON.stringify(body)
  })
  .then((response) => {
    if (response.status >= 200 && response.status < 400) {
      return response;
    }

    const error = new Error(response.statusText);
    error.statusCode = response.status;
    error.response = response;
    throw error;
  })
  .then(response => response.json());

SearchService.search = ({ query, page }) => {
  const requestUrl = `${BASE_URL}/api/v1/public/engines/search`;

  const body = {
    engine_key: window.env.SWIFTYPE_ENGINE_KEY,
    spelling: 'retry',
    filters: {
      page: {
        type: ['article']
      }
    },
    per_page: 10,
    q: query,
    page
  };

  return postRequest(requestUrl, body);
};

SearchService.recordClickthrough = (query, id, url) => {
  const params = $.param({
    t: new Date().getTime(),
    engine_key: window.env.SWIFTYPE_ENGINE_KEY,
    doc_id: id,
    q: query
  });

  metrics.track('click:docs:search:search-result', { trackData: query, track_data2: url });
  const img = new Image();
  img.src = `${BASE_URL}/api/v1/public/analytics/pc?${params}`;
};

export default SearchService;
